import { Appointment } from "../../../model/professional/booking-model";

// Données mockées pour les rendez-vous
export const mockAppointments: Appointment[] = [
  // Rendez-vous en cours
  {
    id: '1',
    clientName: 'Sophie Martin',
    service: 'Coupe femme',
    time: '10:30',
    duration: '45 min',
    totalPrice: 55,
    status: 'confirmed'
  },
  {
    id: '2',
    clientName: 'Thomas Dubois',
    service: 'Coupe homme + barbe',
    time: '11:15',
    duration: '30 min',
    totalPrice: 35,
    status: 'confirmed'
  },
  
  // Rendez-vous à venir
  {
    id: '3',
    clientName: 'Julie Leroy',
    service: 'Coloration',
    time: '14:00',
    duration: '90 min',
    totalPrice: 85,
    status: 'confirmed'
  },
  {
    id: '4',
    clientName: 'Antoine Moreau',
    service: 'Coupe homme',
    time: '15:45',
    duration: '30 min',
    totalPrice: 25,
    status: 'confirmed'
  },
  {
    id: '5',
    clientName: 'Camille Petit',
    service: 'Brushing',
    time: '16:30',
    duration: '45 min',
    totalPrice: 40,
    status: 'confirmed'
  },
  
  // Rendez-vous passés
  {
    id: '6',
    clientName: 'Léa Bernard',
    service: 'Coupe femme',
    time: '09:00',
    duration: '45 min',
    totalPrice: 55,
    status: 'completed'
  },
  {
    id: '7',
    clientName: 'Nicolas Roux',
    service: 'Coupe homme',
    time: '09:45',
    duration: '30 min',
    totalPrice: 25,
    status: 'completed'
  },
  {
    id: '8',
    clientName: 'Emma Fournier',
    service: 'Coloration',
    time: '08:00',
    duration: '90 min',
    totalPrice: 85,
    status: 'cancelled'
  }
];

// Fonction pour filtrer les rendez-vous selon leur statut
export const getFilteredAppointments = () => {
  const currentTime = new Date();
  // Pour les tests, on fixe l'heure à 12:00
  currentTime.setHours(12, 0, 0, 0);
  
  const getAppointmentTime = (timeStr: string) => {
    const [hours, minutes] = timeStr.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return date;
  };
  
  const getAppointmentEndTime = (appointment: Appointment) => {
    const startTime = getAppointmentTime(appointment.time);
    const [duration] = appointment.duration.split(' ')[0].split(':').map(Number);
    const endTime = new Date(startTime);
    endTime.setMinutes(endTime.getMinutes() + duration);
    return endTime;
  };
  
  const ongoing = mockAppointments.filter(appointment => {
    if (appointment.status === 'cancelled') return false;
    const startTime = getAppointmentTime(appointment.time);
    const endTime = getAppointmentEndTime(appointment);
    return currentTime >= startTime && currentTime <= endTime;
  });
  
  const upcoming = mockAppointments.filter(appointment => {
    if (appointment.status === 'cancelled') return false;
    const startTime = getAppointmentTime(appointment.time);
    return currentTime < startTime;
  });
  
  const past = mockAppointments.filter(appointment => {
    if (appointment.status === 'cancelled') return true; // Les annulés sont considérés comme passés
    const endTime = getAppointmentEndTime(appointment);
    return currentTime > endTime;
  });
  
  return {
    ongoing,
    upcoming,
    past,
    all: [...ongoing, ...upcoming, ...past]
  };
};
